<header>
    <app-header headerName="Admin"></app-header>
  </header>
  

  <div class="outer-conatiner">
    <div class="admin-container">
      <app-page-title pageTitle='Village of Volo Admin Portal'></app-page-title>     
       <section class="container-wrapper search-section">
        <mat-tab-group (selectedIndexChange)="selectTab($event)">
            <!-- <mat-tab label="Village Staff" >
               <p class="sub-form-title no-margin">Village Staff</p>
                  <div *ngIf="!tableData"> No Users Found</div> 
                  <app-spinner *ngIf="showSpinner; else content"></app-spinner>     
                   <ng-template #content>
                  <div *ngIf="tableData?.length">
                  <app-table [tableData]="tableData"  [tableColumnsNames]="columnNames"
                 ></app-table>
                 </div>
                </ng-template>
             </mat-tab> -->
            <!-- <mat-tab label="Officer">
               <div *ngIf="selectedTab == 1">
                <p class="sub-form-title no-margin">Officer</p>
                <div *ngIf="!tableDataOfficer"> No Users Found</div> 
                <app-spinner *ngIf="showSpinner; else content"></app-spinner>     
                 <ng-template #content>
                <div *ngIf="tableDataOfficer?.length">
                <app-table [tableData]="tableDataOfficer"  [tableColumnsNames]="columnNames"
               ></app-table>
               </div> 
              </ng-template>
            </div>
             </mat-tab> -->
             <mat-tab label="Users & Roles"> 
              <!-- <p class="sub-form-title no-margin">User</p>
                 <p class="sub-form-title no-margin">Role</p> -->
                 <app-user-roles  *ngIf="selectedTab == 0"></app-user-roles>
                 <!-- <section class="container-wrapper parking-history">  -->
                  <!-- <app-table [tableData]="ELEMENT_DATA"  [tableColumnsNames]="columnNames"></app-table>        -->
                 <!-- </section> -->
          </mat-tab> 
            <!-- <mat-tab label="Car Details">
                <p class="sub-form-title no-margin">Car details</p> Content 3 
            </mat-tab> -->
            <mat-tab label="Addresses">
              <app-address *ngIf="selectedTab === AdminPanelsInterface.ADDRESSES_PANEL"></app-address>
             </mat-tab>
            <mat-tab label="Reasons For Parking">
                <app-reasons *ngIf="selectedTab == AdminPanelsInterface.REASON_FOR_PARKING"></app-reasons>
             </mat-tab>
             <mat-tab label="Year-Cycles">
               <app-year-cycle *ngIf="selectedTab === AdminPanelsInterface.YEAR_CYCLE_PANEL"></app-year-cycle>
              </mat-tab>
              <mat-tab label="Year">
              <app-year *ngIf="selectedTab === AdminPanelsInterface.YEAR_PANEL"></app-year>
              </mat-tab>
             <!-- <mat-tab label="Reasons For Violation">
               <app-reason-violation *ngIf="selectedTab == 6"></app-reason-violation>
            </mat-tab> -->
          </mat-tab-group>
       </section>
    </div>
 </div>
 